<nb-toggle
	(checkedChange)="onCheckedChange($event)"
	[checked]="checked"
></nb-toggle>
